<template>
  <v-skeleton-loader
    v-if="notifications.length"
    :loading="notificationsLoading"
    :types="skeleton"
    type="article"
    class="mb-6"
  >
    <v-card
      v-if="notifications.length"
      class="elevation-1 mb-6 rounded-lg"
      min-width="280"
      max-width="320"
    >
      <v-card-title class="pl-7 pr-7 pt-7 pb-5">Notifikace - sms</v-card-title>
      <v-card-actions class="pl-7 pr-7 pb-7">
        <v-row>
          <v-col v-for="item in notifications" :key="item.id" cols="12" class="ma-0 pt-1 pb-1">
            <v-form rel="form" @submit.prevent="sendTypedNotification('SMS', item.name)">
              <v-btn
                type="submit"
                height="40px"
                depressed
                block
                color="primary"
                :loading="typeSending === item.name"
              >
                {{ item.text }}
              </v-btn>
            </v-form>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-skeleton-loader>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'OrderNotificationSmsForm',
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@1',
      },
      notifications: [],
      notificationsLoading: false,
      typeSending: null,
    }
  },
  watch: {
    'value.type.name': function () {
      this.loadOrderNotifications('SMS')
    },
    'value.statusCode.name': function () {
      this.loadOrderNotifications('SMS')
    },
  },
  created() {
    this.loadOrderNotifications('SMS')
  },
  methods: {
    ...mapActions({
      sendNotification: 'order/sendNotification',
      getOrderNotifications: 'order/getOrderNotifications',
    }),
    sendTypedNotification(channel, type) {
      this.$confirm('', {
        title: 'Odeslat sms?',
        buttonTrueText: 'Ano',
        buttonFalseText: 'Ne',
        icon: '',
        color: 'black',
      }).then((result) => {
        if (result) {
          this.typeSending = type
          this.sendNotification({
            id: this.value.id,
            type: type,
            channel: channel,
          })
            .then(() => {
              this.$emit('update')
            })
            .finally(() => {
              this.typeSending = null
            })
        }
      })
    },
    loadOrderNotifications(channel) {
      this.notificationsLoading = true
      this.getOrderNotifications({
        id: this.value.id,
        channel: channel,
      })
        .then((result) => {
          this.notifications = result.data
        })
        .finally(() => {
          this.notificationsLoading = false
        })
    },
  },
}
</script>
